<header class="nav-header">
  <div class="nav-container" [class.full-width]="fullWidth">

    <!-- Menú hamburguesa -->
    <button class="nav-menu-btn" (click)="toggleMenu.emit()">
      <span class="hamburger-icon">☰</span>
    </button>

    <!-- Logo centrado -->
    <div class="nav-logo">
      <h1>SOMOS QR+</h1>
    </div>

    <!-- Practice Dropdown -->
    <div class="nav-practice">
      <button class="practice-dropdown-btn" (click)="togglePracticeDropdown()">
        <span class="practice-display">{{ getPracticeDisplayText(selectedPractice) }}</span>
        <span class="dropdown-arrow" [ngClass]="{'rotated': isPracticeDropdownOpen}">▼</span>
      </button>

      <!-- Practice Dropdown Menu -->
      <div class="practice-dropdown" [ngClass]="{'show': isPracticeDropdownOpen}">
        <div class="practice-search">
          <input
            type="text"
            [placeholder]="translations.searchPlaceholder"
            (input)="onPracticeSearch($event)"
            [(ngModel)]="practiceSearchTerm"
            class="practice-search-input"
            autocomplete="off"
            spellcheck="false"
          >
        </div>

        <div class="practice-options" *ngIf="!loading">
          <div
            class="practice-option"
            *ngFor="let practice of filteredPractices"
            [ngClass]="{
                            'selected': practice.id === selectedPractice?.id,
                            'all-practices': practice.id === -1
                        }"
            (click)="selectPractice(practice)"
          >
            <span class="practice-text">{{ getPracticeDisplayText(practice) }}</span>
            <span class="check-icon" *ngIf="practice.id === selectedPractice?.id">✓</span>
          </div>
        </div>

        <div class="practice-loading" *ngIf="loading">
          <span>{{ translations.loading }}</span>
        </div>

        <div class="practice-no-results" *ngIf="!loading && filteredPractices.length === 0">
          <span>{{ translations.noResults }}</span>
        </div>
      </div>
    </div>
    <!-- Theme mode toggle -->
    <div class="nav-theme">
      <button
        class="theme-btn"
        (click)="toggleThemeMode()"
        [pTooltip]="isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'"
        tooltipPosition="bottom"
        aria-label="Toggle dark mode">
        <span class="theme-icon" *ngIf="!isDarkMode">
          <!-- Luna: activar dark mode -->
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
          </svg>
        </span>
        <span class="theme-icon" *ngIf="isDarkMode">
          <!-- Sol: volver a modo claro -->
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="5"></circle>
            <line x1="12" y1="1" x2="12" y2="3"></line>
            <line x1="12" y1="21" x2="12" y2="23"></line>
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
            <line x1="1" y1="12" x2="3" y2="12"></line>
            <line x1="21" y1="12" x2="23" y2="12"></line>
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
          </svg>
        </span>
      </button>
    </div>

    <!-- Notifications bell -->
    <div class="nav-notifications">
      <button
        class="notification-btn"
        (click)="toggleNotifications($event)"
        aria-label="Notifications">
        <!-- Icono campanita (puedes reemplazar por svg propio) -->
        <span class="notification-icon"><svg class="notification-icon" width="20" height="20" viewBox="0 0 24 24"
                                             fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"></path>
                        <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"></path>
                    </svg></span>

        <!-- Badge con conteo (opcional) -->
        <span class="notification-badge" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
      </button>

      <!-- Dropdown de notificaciones -->
      <div class="notifications-dropdown" [ngClass]="{'show': isNotificationsOpen}">
        <div class="notifications-header">
          <h3>Notifications</h3>
          <button class="mark-all-read-btn" (click)="goToNotifications($event)">View All</button>
        </div>

        <div class="notifications-list" *ngIf="!loadingNotifications && alerts.length">
          <div class="notification-item" *ngFor="let n of alerts">
            <span class="notification-icon-small">📋</span>
            <div class="notification-content">
              <div class="notification-title">{{ n.title }}</div>
              <div class="notification-message">{{ n.description }}</div>
              <div class="notification-time">{{ n.time }}</div>
            </div>
            <!-- Cerrar individual (opcional) -->
            <!-- <button class="notification-close" (click)="dismiss(n)">×</button> -->
          </div>
        </div>

        <div class="notifications-list" *ngIf="!loadingNotifications && !alerts.length">
          <div class="notification-item">
            <div class="notification-content">
              <div class="notification-message">You’re all caught up 🎉</div>
            </div>
          </div>
        </div>

        <div class="notifications-list" *ngIf="loadingNotifications">
          <div class="notification-item">
            <div class="notification-content">
              <div class="notification-message">Loading notifications…</div>
            </div>
          </div>
        </div>

        <div class="notifications-footer">
          <a class="view-all-notifications" (click)="goToNotifications($event)">View All</a>
        </div>
      </div>
    </div>

    <div class="nav-messages">
      <button class="messages-btn" (click)="goToInvitations($event)" aria-label="Messages">
    <span class="messages-icon">
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M4 7h16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2z"/>
        <path d="M22 9l-10 7L2 9"/>
      </svg>
    </span>
      </button>
    </div>
    <!-- Avatar a la derecha -->
    <div class="nav-profile">
      <button class="profile-btn" (click)="toggleProfileDropdown()">
        <div class="avatar">
          <div class="avatar-initials">{{ userInitials }}</div>
        </div>
      </button>

      <!-- Profile Dropdown -->
      <div class="profile-dropdown" [ngClass]="{'show': isProfileDropdownOpen}">
        <div class="profile-header">
          <div class="profile-avatar">
            <div class="avatar-initials">{{ userInitials }}</div>
          </div>
          <div class="profile-info">
            <div class="profile-name">{{ currentUser?.fullname || 'Joel Cedano' }}</div>
            <div class="profile-email">{{ currentUser?.email || 'jcedano@somosipa.com' }}</div>
          </div>
        </div>

        <div class="profile-divider"></div>

        <div class="profile-options">
          <div class="profile-option language-option" (click)="toggleLanguageDropdown($event)">
            <span class="option-label">Language</span>
            <span class="option-value">
                            <span class="flag-icon">{{ getLanguageFlag(currentLanguage.code) }}</span>
              {{ currentLanguage.text }}
              <span class="dropdown-arrow" [ngClass]="{'rotated': isLanguageDropdownOpen}">▼</span>
                        </span>

            <!-- Language Dropdown -->
            <div class="language-dropdown" [ngClass]="{'show': isLanguageDropdownOpen}">
              <div
                class="language-option"
                *ngFor="let language of availableLanguages"
                [ngClass]="{'selected': language.code === currentLanguage.code}"
                (click)="selectLanguage(language, $event)"
              >
                <span class="flag-icon">{{ getLanguageFlag(language.code) }}</span>
                <span class="language-text">{{ language.text }}</span>
                <span class="check-icon" *ngIf="language.code === currentLanguage.code">✓</span>
              </div>
            </div>
          </div>

          <div class="profile-option" (click)="handleProfileAction('change-password')">
            <span class="option-label">Change Password</span>
          </div>

          <div class="profile-option" (click)="handleProfileAction('logout')">
            <span class="option-label">Log Out</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</header>
